import type { AbstractSketchEdgeObject } from '../../mesh/sketch';
import { SketchRelationKind } from '../../sketch/solver/constraint/relation-compatibility/SketchRelationKinds';

/**
 * 关系标签视觉状态枚举。
 */
export enum RelationMarkerVisualState {
    /** 默认状态。 */
    Default = 'default',
    /** 菜单选中状态。 */
    MenuSelected = 'menu-selected',
    /** 点击选中状态。 */
    ClickSelected = 'click-selected',
    /** 鼠标移入状态。 */
    Hover = 'hover',
}

/**
 * 标签视觉样式定义。
 */
export interface MarkerVisualStyle {
    /** 背景颜色。 */
    backgroundColor: string;
    /** 图形颜色。 */
    glyphColor: string;
}

/**
 * 标签状态机输入参数。
 */
export interface MarkerStateMachineInput {
    /** 菜单选中标签键集合。 */
    menuSelectedMarkerKeys?: string[];
    /** 点击选中标签键集合。 */
    clickSelectedMarkerKeys?: string[];
    /** 鼠标移入标签键集合。 */
    hoveredMarkerKeys?: string[];
}

/**
 * 单个对象上的标签定义。
 */
export interface MarkerDefinition {
    /** 所属对象。 */
    owner: AbstractSketchEdgeObject;
    /** 关系类型。 */
    relationKind: SketchRelationKind;
    /** 约束 ID。 */
    constraintId: number;
}

/**
 * 关系标签记录。
 */
export interface RelationMarkerRecord {
    /** 所属对象 ID。 */
    objectId: string;
    /** 标签对象列表。 */
    markerObjects: import('../../mesh/SketchRelationMarkerLabelObject').SketchRelationMarkerLabelObject[];
    /** 标签关系类型列表。 */
    markerTypes: SketchRelationKind[];
    /** 标签键列表。 */
    markerKeys: string[];
}
